import react, { Fragment, useState, useEffect } from 'react'

import axios from 'axios'
import { toast } from 'react-toastify'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import { Form } from 'react-bootstrap'
import {} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Image from './logo (2).png'
import { AiOutlineLogout } from 'react-icons/ai'
import logo1 from '../../StudentRegristrationDesign/jain logo.png'
import { Button, DatePicker, Layout,   Grid } from 'antd'
import moment from 'moment'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import Sidebar from './sidebar'
import Header from './Header'
import { AluminiAdd, AluminiDistrictFind, AluminiStateFindAll, AluminiTalukaFind, AluminiUpdateProfile, EventAluminiFindOne } from '../../ApiFile'

const { Content } = Layout
const { useBreakpoint } = Grid

const EditAluminiProfile = () => {

 const navigate = useNavigate()

  const currentYear = new Date().getFullYear()
  const [yearFrom, setYearFrom] = useState()
  const [yearTo, setYearTo] = useState()
  

  const handleChangeFrom = (e) => {
    setYearFrom(e.target.value)
  }
  const handleChangeTo = (e) => {
    setYearTo(e.target.value)
  }

  const userdata = JSON.parse(sessionStorage.getItem('userdata'))
  const id = userdata.id
  const email_id = userdata.email_id

  const [stateList, setStateList] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [talukaList, setTalukaList] = useState([])
  const [pDistrictList, setPDistrictList] = useState([]) // new state for permanent address district list
  const [pTalukaList, setPTalukaList] = useState([]) // new state for permanent address taluka list

  const [userId, setUserId] = useState('')
  const [fname, setFname] = useState('')
  const [mname, setMname] = useState('')
  const [lname, setLname] = useState('')
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedTaluka, setSelectedTaluka] = useState('')
  const [pSelectedState, setPSelectedState] = useState('')
  const [pSelectedDistrict, setPSelectedDistrict] = useState('')
  const [pSelectedTaluka, setPSelectedTaluka] = useState('')

  const [currentAddress, setCurrentAddress] = useState('')
  const [currentPincode, setCurrentPincode] = useState('')
  const [permanentAddress, setPermanentAddress] = useState('')
  const [permanentPincode, setPermanentPincode] = useState('')

  const [blood_group, setBlood_group] = useState('')
  const [qualification, setQualification] = useState('')
  const [date, setDate] = useState(null)
  const [mob_no, setMob_no] = useState('')
  const [alternate_mobno, setAlternate_mobno] = useState('')
  const [professional_category, setProfessional_category] = useState('')
  const [service_name, setService_name] = useState('')
  const [achievements, setAchievements] = useState('')
  const [file, setFile] = useState(null)

   useEffect(() => {

    const fetchData = async () => {
      try {
        const response = await axios.get(`${EventAluminiFindOne}/${id}`) // Replace with your actual API endpoint
        const data = response.data[0]

        // Assuming the structure of data is correct and matches your keys
        setUserId(data.id || '')
        setFname(data.f_name || '')
        setMname(data.m_name || '')
        setLname(data.l_name || '')
        setSelectedState(data.state_id || '')
        setSelectedDistrict(data.district_id || '')
        setSelectedTaluka(data.taluka_id || '')
        setPSelectedState(data.alternate_state_id || '')
        setPSelectedDistrict(data.alternate_district_id || '')
        setPSelectedTaluka(data.alternate_taluka_id || '')

        setCurrentAddress(data.current_address || '')
        setCurrentPincode(data.pincode || '')
        setPermanentAddress(data.alternate_address || '')
        setPermanentPincode(data.alternate_pincode || '')

        setYearFrom(data.fromyearof_boarding || '')
        setYearTo(data.toyearof_boarding || '')

        setBlood_group(data.blood_group || '')
        setQualification(data.qualification || '')
        // setDate(data.dateofbirth ? dayjs(data.dateofbirth).format('DD/MM/YYYY') : null)
        const parsedDate = dayjs(data.dateofbirth, 'DD/MM/YY');
        setDate(parsedDate || '')
        // setDate(data.dateofbirth ? dayjs(data.dateofbirth) : null)


        setMob_no(data.mob_no || '')
        setAlternate_mobno(data.alternate_mobno || '')
        setProfessional_category(data.professional_category || '')
        setService_name(data.business_service_name || '')
        setAchievements(data.achievements || '')
        setFile(data.profile_img || null) 
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [])


  useEffect(() => {
    axios
      .get(AluminiStateFindAll)
      .then((response) => {
        setStateList(response.data)
      })
      .catch((error) => {
        // console.error('Error fetching states:', error);
      })
  }, [])

  useEffect(() => {
    if (selectedState !== '') {
      axios
        .get(`${AluminiDistrictFind}/${selectedState}`)
        .then((response) => {
          setDistrictList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching districts:', error);
        })
    }
  }, [selectedState])

  useEffect(() => {
    if (selectedState !== '' && selectedDistrict !== '') {
      axios
        .get(`${AluminiTalukaFind}/${selectedState}/${selectedDistrict}`)
        .then((response) => {
          setTalukaList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching talukas:', error);
        })
    }
  }, [selectedState, selectedDistrict])

  useEffect(() => {
    if (pSelectedState !== '') {
      axios
        .get(`${AluminiDistrictFind}/${pSelectedState}`)
        .then((response) => {
          setPDistrictList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching permanent address districts:', error);
        })
    }
  }, [pSelectedState])

  useEffect(() => {
    if (pSelectedState !== '' && pSelectedDistrict !== '') {
      axios
        .get(`${AluminiTalukaFind}/${pSelectedState}/${pSelectedDistrict}`)
        .then((response) => {
          setPTalukaList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching permanent address talukas:', error);
        })
    }
  }, [pSelectedState, pSelectedDistrict])

  const handleStateChange = (e) => {
    setSelectedState(e.target.value)
    setSelectedDistrict('')
    setSelectedTaluka('')
  }

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value)
    setSelectedTaluka('')
  }

  const handleTalukaChange = (e) => {
    setSelectedTaluka(e.target.value)
  }

  const handlePStateChange = (e) => {
    setPSelectedState(e.target.value)
    setPSelectedDistrict('')
    setPSelectedTaluka('')
  }

  const handlePDistrictChange = (e) => {
    setPSelectedDistrict(e.target.value)
    setPSelectedTaluka('')
  }

  const handlePTalukaChange = (e) => {
    setPSelectedTaluka(e.target.value)
  }
  const [responseMessage, setResponseMessage] = useState('')

  //checkbox
  const [usePermanentAddress, setUsePermanentAddress] = useState(false)
  const handleUsePermanentAddressChange = (e) => {
    setUsePermanentAddress(e.target.checked)
    if (e.target.checked) {
      setPSelectedState(selectedState)
      setPSelectedDistrict(selectedDistrict)
      setPSelectedTaluka(selectedTaluka)
      setPermanentAddress(currentAddress)
      setPermanentPincode(currentPincode)
    } else {
      setPSelectedState('')
      setPSelectedDistrict('')
      setPSelectedTaluka('')
      setPermanentAddress('')
      setPermanentPincode('')
    }
  }

  const handleCurrentAddressChange = (event) => {
    setCurrentAddress(event.target.value)
  }

  const handleCurrentPincodeChange = (e) => {
    // setCurrentPincode(event.target.value);
    const input = e.target.value
    if (/^\d*$/.test(input) && input.length <= 6) {
      // Update state only if the input is a number and within the length limit
      setCurrentPincode(input)
    }
  }

  const [errors, setErrors] = useState({})

  // Validation functions
  const validateMobileNumber = (number) => /^[0-9]{10}$/.test(number)
  const validatePincode = (pincode) => /^[0-9]{6}$/.test(pincode)

  //add api
  const handleSubmit = async (event) => {
    event.preventDefault()

     // List of required fields
  // List of required fields (add every field you want compulsory)
  const requiredFields = [
    { value: file, name: "Profile Photo" },
    { value: fname, name: "First Name" },
    { value: mname, name: "Middle Name" },
    { value: lname, name: "Last Name" },
    { value: date, name: "Date of Birth" },
    { value: blood_group, name: "Blood Group" },
    { value: email_id, name: "Email" },
    { value: mob_no, name: "Mobile Number" },
    { value: qualification, name: "Qualification" },
    { value: professional_category, name: "Professional Category" },
    { value: service_name, name: "Service/Company Name" },
    { value: yearFrom, name: "From Year" },
    { value: yearTo, name: "To Year" },

    // Current Address
    { value: currentAddress, name: "Current Address" },
    { value: currentPincode, name: "Current Pincode" },
    { value: selectedState, name: "Current State" },
    { value: selectedDistrict, name: "Current District" },
    { value: selectedTaluka, name: "Current Taluka" },

    // Permanent Address
    { value: permanentAddress, name: "Permanent Address" },
    { value: permanentPincode, name: "Permanent Pincode" },
    { value: pSelectedState, name: "Permanent State" },
    { value: pSelectedDistrict, name: "Permanent District" },
    { value: pSelectedTaluka, name: "Permanent Taluka" },
  ];
  // Check for any empty required fields
  const missingField = requiredFields.find((field) => !field.value)

  if (missingField) {
    toast.error(`${missingField.name} is required`)
    return
  }

    const formData = new FormData()
    const formattedDate = date ? dayjs(date).format('DD/MM/YYYY') : null

    try {
      formData.append('profile_img', file)
      formData.append('f_name', fname)
      formData.append('m_name', mname)
      formData.append('l_name', lname)
      formData.append('qualification', qualification)
      formData.append('current_address', currentAddress)
      formData.append('pincode', currentPincode)
      formData.append('state', selectedState)
      formData.append('district', selectedDistrict)
      formData.append('taluka', selectedTaluka)
      formData.append('alternate_address', permanentAddress)
      formData.append('alternate_pincode', permanentPincode)
      formData.append('alternate_state', pSelectedState)
      formData.append('alternate_district', pSelectedDistrict)
      formData.append('alternate_taluka', pSelectedTaluka)
      formData.append('dateofbirth', formattedDate)
      formData.append('blood_group', blood_group)
      formData.append('email_id', email_id)
      formData.append('mob_no', mob_no)
      formData.append('alternate_mobno', alternate_mobno)
      formData.append('professional_category', professional_category)
      formData.append('business_service_name', service_name)
      formData.append('fromyearof_boarding', yearFrom)
      formData.append('toyearof_boarding', yearTo)
      formData.append('achievements', achievements)

      // Validation code here...

      const response = await axios.put(`${AluminiUpdateProfile}/${userId}`, formData)

            if (response.data == "Failed to upload file") {
              toast.error('Failed to upload Alumini data!')
            }
            else if(response.data == "UPDATE"){
              toast.success('Alumini data updated successfully!')
              navigate('/AluminiDashboard')
            }
            
    } catch (error) {
      console.error('Error occurred while submitting the form:', error)
    }
  }


  const inputStyle = {
    marginTop: '-9px',
    height: '37px',
  }

 
   return (

      <Layout>
          <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
              {/* Sidebar on the left for desktop */}
              <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
                <Sidebar />
              </div>

              {/* Main content on the right */}
              <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
                <Header />
                <Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                      <Container className="pb-5">
                              <div
                                className="shadow"
                                style={{
                                  backgroundColor: '#B9D9EB',
                                  borderRadius: '10px',
                                  padding: '20px',
                                  marginTop: '20px',
                                }}
                              >
                      
                                <Row className='px-2 m-0'>
                                    <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
                                      Alumni Update Profile Form
                                </h5>
                                </Row>
                                <Row>
                                  <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Label>Upload Photo</Form.Label>
                                    <Form.Control
                                      type="file"
                                      accept=".png, .jpg, .jpeg"
                                      onChange={(e) => setFile(e.target.files[0])}
                                      required
                                    />
                                  </Form.Group>
                                </Row>
                                <Row className="mb-3">
                                  <Form.Label>Full Name</Form.Label>
                                  <Form.Group as={Col} xs={12} sm={4} className='mb-1' controlId="formGridFname">
                                    <Form.Control
                                      type="text"
                                      placeholder="First name"
                                      required
                                      value={fname}
                                      onChange={(e) => setFname(e.target.value)}
                                    />
                                  </Form.Group>
                                  <Form.Group as={Col} xs={12} sm={4} className='mb-1' controlId="formGridMname">
                                    <Form.Control
                                      type="text"
                                      placeholder="Middle name"
                                      required
                                      value={mname}
                                      onChange={(e) => setMname(e.target.value)}
                                    />
                                  </Form.Group>
                                  <Form.Group as={Col} xs={12} sm={4} className='mb-1' controlId="formGridLname">
                                    <Form.Control
                                      type="text"
                                      placeholder="Last Name"
                                      required
                                      value={lname}
                                      onChange={(e) => setLname(e.target.value)}
                                    />
                                  </Form.Group>
                                </Row>
                      
                                <Row className="mb-3">
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formFile">
                                    <Form.Label>Date of Birth</Form.Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                          format="DD-MM-YYYY"
                                          className="w-100 rounded"
                                          style={inputStyle}
                                          required
                                          value={date}
                                          onChange={(newDate) => setDate(newDate)}
                                          slotProps={{ textField: { size: 'small' } }}
                                        />
                                      </DemoContainer>
                                    </LocalizationProvider>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridPassword">
                                    <Form.Label>Blood Group</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      value={blood_group}
                                      onChange={(e) => setBlood_group(e.target.value)}
                                      required
                                    >
                                      <option>Choose...</option>
                                      <option value="A +ve">A +ve</option>
                                      <option value="A -ve">A -ve</option>
                                      <option value="B +ve">B +ve</option>
                                      <option value="B -ve">B -ve</option>
                                      <option value="AB +ve">AB +ve</option>
                                      <option value="AB -ve">AB -ve</option>
                                      <option value="O +ve">O +ve</option>
                                      <option value="O -ve">O -ve</option>
                                      <option value="Other">Other</option>
                                    </Form.Select>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={6} controlId="formGridEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                      type="email"
                                      maxLength={25}
                                      placeholder=""
                                      value={email_id}
                                      required disabled
                                    />
                                  </Form.Group>
                                </Row>
                                <hr style={{ height: '3px' }} />
                      
                                <Row className="mb-3">

                                <span className='m-2 p-0' style={{fontSize:"18px",fontWeight:"bold"}}>Current Detail Address</span>

                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridState">
                                    <Form.Label>State</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      name="state"
                                      value={selectedState}
                                      onChange={handleStateChange}
                                      required
                                    >
                                      <option value="">Choose...</option>
                                      {stateList.map((state) => (
                                        <option key={state.id} value={state.id}>
                                          {state.state_name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridDistrict">
                                    <Form.Label>District</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      name="district"
                                      value={selectedDistrict}
                                      onChange={handleDistrictChange}
                                      required
                                    >
                                      <option value="">Choose...</option>
                                      {districtList.map((district) => (
                                        <option key={district.id} value={district.id}>
                                          {district.districtenname}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridTaluka">
                                    <Form.Label>Taluka</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      name="taluka"
                                      value={selectedTaluka}
                                      onChange={handleTalukaChange}
                                      required
                                    >
                                      <option value="">Choose...</option>
                                      {talukaList.map((taluka) => (
                                        <option key={taluka.id} value={taluka.id}>
                                          {taluka.talukaenname}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridPassword">
                                    <Form.Label>Pin code</Form.Label>
                                    <Form.Control
                                      type="number"
                                      placeholder="pincode"
                                      maxLength={6}
                                      value={currentPincode}
                                      onChange={handleCurrentPincodeChange}
                                      required
                                    />
                                    {errors.currentPincode && (
                                      <p className="text-danger">{errors.currentPincode}</p>
                                    )}
                                  </Form.Group>
                                </Row>
                      
                                <div className="Caddress">
                                
                                  <Form.Group as={Col} xs={12} controlId="formGridEmail">
                                    <Form.Label>Detail Address Line</Form.Label>
                                    <Form.Control
                                      type="text"
                                      maxLength={200}
                                      value={currentAddress}
                                      onChange={handleCurrentAddressChange}
                                      placeholder="House Name/No/Road/Chowk/Colony/Landmark/P.O/Village/City"
                                      required
                                    />
                                  </Form.Group>
                                </div>

                                <hr style={{ height: '3px' }} />
                                <Form.Group
                                  as={Col}
                                  xs={12}
                                  className="mb-4"
                                  sm={12}
                                  controlId="formGridUsePermanentAddress"
                                >
                                  <Form.Check
                                    type="checkbox"
                                    label="Use current address as permanent address"
                                    checked={usePermanentAddress}
                                    onChange={handleUsePermanentAddressChange}
                                  />
                                </Form.Group>
                      
                                <Row className="mb-3">

                                  <span className='m-2 p-0' style={{fontSize:"18px",fontWeight:"bold"}}>Permanent Detail Address</span>

                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridPState">
                                    <Form.Label>State</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      name="alternate_state"
                                      value={pSelectedState}
                                      onChange={handlePStateChange}
                                      required
                                    >
                                      <option value="">Choose...</option>
                                      {stateList.map((state) => (
                                        <option key={state.id} value={state.id}>
                                          {state.state_name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridPDistrict">
                                    <Form.Label>District</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      name="alternate_district"
                                      value={pSelectedDistrict}
                                      onChange={handlePDistrictChange}
                                      required
                                    >
                                      <option value="">Choose...</option>
                                      {pDistrictList.map((district) => (
                                        <option key={district.id} value={district.id}>
                                          {district.districtenname}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridPTaluka">
                                    <Form.Label>Taluka</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      name="alternate_taluka"
                                      value={pSelectedTaluka}
                                      onChange={handlePTalukaChange}
                                      required
                                    >
                                      <option value="">Choose...</option>
                                      {pTalukaList.map((taluka) => (
                                        <option key={taluka.id} value={taluka.id}>
                                          {taluka.talukaenname}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={3} controlId="formGridPassword">
                                    <Form.Label>Pin code</Form.Label>
                                    <Form.Control
                                      type="number"
                                      maxLength={6}
                                      placeholder=""
                                      value={permanentPincode}
                                      //  onChange={(e) => setPermanentPincode(e.target.value)}
                                      onChange={(e) => {
                                        const input = e.target.value
                                        // Check if the input consists only of numbers and has a maximum length of 6
                                        if (/^\d*$/.test(input) && input.length <= 6) {
                                          // Update state only if the input is a number and within the length limit
                                          setPermanentPincode(input)
                                        }
                                      }}
                                      required
                                    />
                                    {errors.permanentPincode && (
                                      <p className="text-danger">{errors.permanentPincode}</p>
                                    )}
                                  </Form.Group>
                                </Row>
                      
                                <div className="Paddress">
                                  <Form.Group as={Col} xs={12} controlId="formGridEmail">
                                    <Form.Label className="pt-3">Detail Address Line</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="House Name/No/Road/Chowk/Colony/Landmark/P.O/Village/City"
                                      value={permanentAddress}
                                      onChange={(e) => setPermanentAddress(e.target.value)}
                                      required
                                    />
                                  </Form.Group>
                                </div>
                                <hr style={{ height: '3px' }} />
                      
                                <Row className="mb-3">
                                  <Form.Group as={Col} xs={12} sm={6}>
                                    <Form.Label>Mobile(WhatsApp) Number</Form.Label>
                                    <Form.Control
                                      id="mobileNumber"
                                      type='number'
                                      placeholder="Mobile Number"
                                      value={mob_no}
                                      onChange={(e) => setMob_no(e.target.value)}
                                      required
                                    />
                                    {errors.mob_no && <p className="text-danger">{errors.mob_no}</p>}
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={6}>
                                    <Form.Label>Alternate Number</Form.Label>
                                    <Form.Control
                                      id="mobileNumber"
                                      type='number'
                                      placeholder="Mobile Number"
                                      value={alternate_mobno}
                                      onChange={(e) => setAlternate_mobno(e.target.value)}
                                    />
                                    {errors.alternate_mobno && (
                                      <p className="text-danger">{errors.alternate_mobno}</p>
                                    )}
                                  </Form.Group>
                                </Row>
                      
                                <Row className="mb-3">
                                  <Form.Group as={Col} xs={12} sm={6} controlId="formGridEmail">
                                    <Form.Label>Qualification</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      maxLength={200}
                                      value={qualification}
                                      onChange={(e) => setQualification(e.target.value)}
                                      required
                                    />
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={6} controlId="formGridState">
                                    <Form.Label>Professional Category</Form.Label>
                                    <Form.Select
                                      defaultValue="Choose..."
                                      value={professional_category}
                                      onChange={(e) => setProfessional_category(e.target.value)}
                                      required
                                    >
                                      <option>Choose...</option>
                                      <option value="Teacher/Professor">Teacher/Professor</option>
                                      <option value="Chef">Chef</option>
                                      <option value="Engineer">Engineer</option>
                                      <option value="Software IT">Software IT</option>
                                      <option value="Lawyer">Lawyer</option>
                                      <option value="Chartered Accountant">
                                        Chartered Accountant
                                      </option>
                                      <option value="Aviator">Aviator</option>
                                      <option value="Health professional">Health professional</option>
                                      <option value="Architect">Architect</option>
                                      <option value="Analyst">Analyst</option>
                                      <option value="Data Engineer">Data Engineer</option>
                                      <option value="Makeup Artist">Makeup Artist</option>
                                      <option value="Medical Representative">
                                        Medical Representative
                                      </option>
                                      <option value="Flight Attendant">Flight Attendant</option>
                                      <option value="Customer Service Representative">
                                        Customer Service Representative
                                      </option>
                                      <option value="Network Administrator">
                                        Network Administrator
                                      </option>
                                      <option value="Accountant">Accountant</option>
                                      <option value="Physician">Physician</option>
                                      <option value="Secretary">Secretary</option>
                                      <option value="Dentist">Dentist</option>
                                      <option value="Designer">Designer</option>
                                      <option value="Economist">Economist</option>
                                      <option value="Dietitians And Nutritionists">
                                        Dietitians And Nutritionists
                                      </option>
                                      <option value="Air Traffic Controller">
                                        Air Traffic Controller
                                      </option>
                                      <option value="Photographer">Photographer</option>
                                      <option value="Mechanic">Mechanic</option>
                                      <option value="Driver">Driver</option>
                                      <option value="Personal Stylist">Personal Stylist</option>
                                      <option value="Aeronautical Engineer">
                                        Aeronautical Engineer
                                      </option>
                                      <option value="Business Consultant">Business Consultant</option>
                                      <option value="Software Engineer">Software Engineer</option>
                                      <option value="Data Scientist">Data Scientist</option>
                                      <option value="Advocate">Advocate</option>
                                      <option value="Veterinarian">Veterinarian</option>
                                      <option value="Businessperson">Businessperson</option>
                                      <option value="Web Designer">Web Designer</option>
                                      <option value="Scientist">Scientist</option>
                                      <option value="Firefighter">Firefighter</option>
                                      <option value="Journalist">Journalist</option>
                                      <option value="Politician">Politician</option>
                                      <option value="Farmer">Farmer</option>
                                      <option value="Judge">Judge</option>
                                      <option value="Civil Engineer">Civil Engineer</option>
                                      <option value="Technician">Technician</option>
                                      <option value="Design Engineer">Design Engineer</option>
                                      <option value="Private Investigator">
                                        Private Investigator
                                      </option>
                                      <option value="Geologist">Geologist</option>
                                      <option value="Merchant">Merchant</option>
                                      <option value="Chemist">Chemist</option>
                                      <option value="Pharmasist">Pharmasist</option>
                                      <option value="Civil Contractor">Civil Contractor</option>
                                      <option value="Tax Consultant">Tax Consultant</option>
                                      <option value="Policeman">Policeman</option>
                                      <option value="Civil Administration">
                                        Civil Administration
                                      </option>
                                      <option value="Govt. Service man">Govt. Service man</option>
                                      <option value="Student">Student</option>
                                      <option value="Defence Services">Defence Services</option>
                                      <option value="Electrician">Electrician</option>
                                      <option value="Other">Other</option>
                                    </Form.Select>
                                  </Form.Group>
                                </Row>
                      
                                <Row className="mb-3">
                                  <Form.Group as={Col} xs={12} sm={6} controlId="formGridEmail">
                                    <Form.Label>
                                      Name & Address Of Business/Company/Employer
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={service_name}
                                      onChange={(e) => setService_name(e.target.value)}
                                    />
                                  </Form.Group>
                      
                                  <Form.Group as={Col} xs={12} sm={6} controlId="formGridYearRange">
                                <Form.Label>Year of Boarding Residence</Form.Label>
                                <div className="d-flex flex-column flex-md-row gap-2">
                                  <Form.Select
                                    value={yearFrom}
                                    name="fromyear"
                                    onChange={handleChangeFrom}
                                    required
                                  >
                                    {[...Array(50)].map((_, index) => (
                                      <option key={index} value={currentYear - index}>
                                        From ({currentYear - index})
                                      </option>
                                    ))}
                                  </Form.Select>

                                  <Form.Select
                                    value={yearTo}
                                    name="toyear"
                                    onChange={handleChangeTo}
                                    required
                                  >
                                    {[...Array(50)].map((_, index) => (
                                      <option key={index} value={currentYear - index}>
                                        To ({currentYear - index})
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                              </Form.Group>

                                </Row>
                                <hr style={{ height: '3px' }} />
                      
                      
                                <Form.Group as={Col} xs={12} controlId="formGridEmail">
                                  <Form.Label>Special Achievements</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder=""
                                    value={achievements}
                                    onChange={(e) => setAchievements(e.target.value)}
                                  />
                                </Form.Group>
                    
                      
                                <div className="text-center m-1">
                                  <Button
                                    variant="primary"
                                    onClick={handleSubmit}
                                    className="regbtn p-3"
                                    style={{ backgroundColor: 'rgb(0, 120, 215)', color: 'white' }}
                                  >
                                   Update Profile
                                  </Button>
                                </div>

                              </div>
                      </Container>
                </Content>
           </div>
           </div>
         </Layout>
   )
 }


export default EditAluminiProfile